export default "__VITE_ASSET__r03n_x1T__"